module.exports = __webpack_public_path__ + "static/media/main_banner_09.de23c7dc.png";